<template>
  <div class="col-4 pb-3">
    <b-card :header="mill.millName">
      <b-card-text>
        <div class="row">W młynie aktualnie produkowane jest:</div>
        <div class="row">
          <div class="col-8">
            <span v-if="mill.couvertureId">
              <b class="couvertureName">{{ mill.couvertureName }}</b>
              <i class="fas fa-edit ml-2" style="cursor: pointer;" @click="openChangeRecipeModal" title="Zmień recepturę"></i>
              <br />
              Waga: <span class="couvertureWeight">{{ mill.couvertureWeight }}</span> kg
            </span>
            <span v-if="!mill.couvertureId">Młyn jest pusty</span>
          </div>
          <div class="col-4">
            <a
              class="float-right"
              v-if="mill.couvertureId"
              :href="'#/HistoriaKuwertury/' + mill.couvertureId"
              >Sprawdź historię</a
            >
          </div>
        </div>
      </b-card-text>

      <div v-if="!mill.couvertureId">
        <div class="row">
          <div class="col">
            <b-button
              :href="'#/StworzKuwerture/' + mill.millId"
              variant="primary"
              class="grid-button-full createCouvertureLink"
              >Stwórz kuwerturę</b-button
            >
          </div>
          <div class="col">
            <b-button
              :href="'#/WymieszajKuwertury/' + mill.millId"
              variant="primary"
              class="grid-button-full"
              >Wymieszaj kuwertury</b-button
            >
          </div>
        </div>
      </div>
      <div v-if="mill.couvertureId">
        <div class="row">
          <div class="col">
            <b-button
              :href="'#/EdytujKuwerture/' + mill.couvertureId"
              variant="primary"
              class="grid-button-full"
              >Edytuj kuwerturę</b-button
            >
          </div>

          <div class="col">
            <b-button
              variant="primary"
              class="grid-button-full putCouvertureOnShelf"
              @click="TakeOutCouverture(mill)"
              >Zlej kuwerturę i odłóż na półkę</b-button
            >
          </div>
        </div>
      </div>
    </b-card>

    <ChangeCouvertureRecipeModal
      ref="changeRecipeModal"
      :mill="mill"
      @RecipeChanged="handleRecipeChanged"
    />
  </div>
</template>

<script>
import ChangeCouvertureRecipeModal from './ChangeCouvertureRecipeModal.vue';

export default {
  name: "DisplayMillItem",
  components: {
    ChangeCouvertureRecipeModal
  },
  props: ["mill"],
  methods: {
    TakeOutCouverture(mill) {
      this.$emit("TakeOutCouverture", mill);
    },
    openChangeRecipeModal() {
      this.$refs.changeRecipeModal.openModal();
    },
    handleRecipeChanged() {
      this.$emit('RecipeChanged');
    }
  },
};
</script>